import React, { useState, useContext } from 'react'
import Button from '../SelectValue/Button'
import PinInput from 'react-pin-input';
import { useNavigate } from 'react-router-dom';
import Loading from '../SelectValue/Loading';
import { toast } from 'react-toastify';
import postService from '../../Services/post-service';
import { UserContext } from '../../Context/UserContext';
function CurrentPin() {
  const { userDetails } = useContext(UserContext);
  const navigator = useNavigate()
  const [loading, setLoading] = useState(false)
  const [pin, setPin] = useState('')
  const onSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    if (pin.length === 4) {
      setLoading(false)
      localStorage.setItem('currentpin', pin)
      navigator('/settings/changepin/newpin')
    } else {
      setLoading(false)
      toast.error('Pin should be 4 digit')
    }

  }

  const resetPin = () => {
    const parsedDetails = userDetails || {};
    const email = parsedDetails?.email || parsedDetails?.emailAddress || "";

    if (!email) {
      toast.error('User email not found. Please log in again.');
      return;
    }

    setLoading(true);
    import('../../Services/get-service').then(m => {
      m.default.forgetPin(email).then(
        (response) => {
          setLoading(false);
          if (response.data.statusCode === 200) {
            localStorage.setItem('requestIdr', response.data.data.requestId);
            localStorage.setItem('pin_reset_token', response.data.data.token);
            toast.success('OTP sent to your email');
            setTimeout(() => navigator('/settings/resetpin/otp'), 2000);
          } else {
            toast.error(response.data.description || 'Failed to initiate pin reset');
            setTimeout(() => window.location.reload(), 2000);
          }
        },
        (error) => {
          setLoading(false);
          toast.error('Pin reset Failed');
          setTimeout(() => window.location.reload(), 2000);
          return;
        }
      );
    });
  }


  return (
    <div className=''>
      <Loading
        open={loading}
      />
      <div className=' mt-10 '>

        <p className=' mb-3 text-back-color2'>Enter your current  Zouse PIN</p>
        <div className='  mt-5'>

          <div >
            <form onSubmit={onSubmit}>
              <div className=' w-full flex justify-center'>

                <PinInput
                  length={4}
                  initialValue={pin}
                  secret
                  onChange={(value, index) => {
                    setPin(value)
                  }}
                  type="numeric"
                  inputMode="number"
                  style={{ padding: '8px', }}
                  inputStyle={{ borderColor: '#00BC67', backgroundColor: '#FAFBFC', borderRadius: 8, }}
                  inputFocusStyle={{ borderColor: '#00BC67', backgroundColor: '#CCF2E1' }}
                  onComplete={(value, index) => {
                    setPin(value)
                  }}
                  autoSelect={true}
                  regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />
              </div>
              <p className=' font-[500] text-primary-color6 text-center mt-10'>Forgot PIN?<span onClick={resetPin} className=' cursor-pointer text-primary-color'>Reset</span></p>

              <div className=' grid grid-cols-1 mb-5 mt-6'>
                <Button
                  name='Next'
                />
              </div>

            </form>

          </div>

        </div>
      </div>
    </div>
  )
}

export default CurrentPin